import * as React from 'react';

import { Flexbox } from '../components/Flexbox';
import { Message } from '../components/Message';

const FIXED_TIME = '2024-12-31T00:00:00.000Z';

export const WithFixedTimeDecorator = (Story: React.ComponentType): JSX.Element => {
    useMockDate();

    return (
        <Flexbox
            gap="20px"
            sx={{
                flexDirection: 'column',
            }}
        >
            <Message
                variant="blue"
                attention="low"
                size="small"
                title="Fixed time"
                message={`This component has mocked the time to ${FIXED_TIME}`}
            />
            <Story />
        </Flexbox>
    );
};

function useMockDate() {
    const [, setForceRerender] = React.useState(0);

    React.useEffect(() => {
        const normalDate = window.Date;
        class FixedDate extends Date {
            // @ts-ignore
            constructor(...args) {
                if (args.length === 0) {
                    super(FIXED_TIME);
                    return;
                }
                // @ts-ignore
                super(...args);
            }
        }
        // @ts-ignore
        window.Date = FixedDate;
        setForceRerender((v) => v + 1);
        return () => {
            window.Date = normalDate;
        };
    }, []);
}
